var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRating2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc4602"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 1,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9177",
    "data-name": "Group 9177",
    transform: "translate(-3343 -10364)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_440",
    "data-name": "Ellipse 440",
    cx: 37,
    cy: 37,
    r: 37,
    transform: "translate(3343 10364)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_445",
    "data-name": "Ellipse 445",
    cx: 34,
    cy: 34,
    r: 34,
    transform: "translate(3346 10367)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9172",
    "data-name": "Group 9172",
    transform: "translate(3362.882 10389.49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8885",
    "data-name": "Path 8885",
    d: "M448.888,22.487a5.543,5.543,0,1,1-5.543-5.543,5.543,5.543,0,0,1,5.543,5.543",
    transform: "translate(-437.803 -16.944)",
    fill: "#40210f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8886",
    "data-name": "Path 8886",
    d: "M563.98,22.487a5.543,5.543,0,1,0,5.543-5.543,5.543,5.543,0,0,0-5.543,5.543",
    transform: "translate(-540.828 -16.944)",
    fill: "#40210f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8887",
    "data-name": "Path 8887",
    d: "M491.23,125.992a1.565,1.565,0,0,1-1.326-.731,10.138,10.138,0,0,0-8.211-4.355,10.5,10.5,0,0,0-8.225,4.376,1.566,1.566,0,0,1-2.623-1.712,13.624,13.624,0,0,1,10.847-5.8,13.312,13.312,0,0,1,10.864,5.822,1.567,1.567,0,0,1-1.327,2.4",
    transform: "translate(-464.575 -99.272)",
    fill: "#40210f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating2);
export default __webpack_public_path__ + "static/media/rating_2.85ee0de34904e4004db2093a5dfd4b63.svg";
export { ForwardRef as ReactComponent };